<template>
	<az-container class="partes-envolvidas mt-4">
		<az-toolbar class="interna az-toolbar">
			<template #actions>
				<botao-primario
					id="adicionarParteEnvolvida"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					v-az-auth="permissoes.ataParteEnvolvidaCriar"
					@click="abrirModalAdicionar"
				></botao-primario>
			</template>
		</az-toolbar>

		<partes-envolvidas-listagem
			:itens="listagem.itens"
			:paginacao="paginacao"
			:total-itens="listagem.totalItens"
			:total-paginas="listagem.totalPaginas"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem"
		></partes-envolvidas-listagem>

		<modal-adicionar-parte-envolvida
			v-if="isModalAdicionarVisivel"
			ref="modalAdicionarParteEnvolvida"
			:exibir="isModalAdicionarExibido"
			@fechar-modal="fecharModalAdicionar"
			@salvar="validarParteEnvolvida"
		></modal-adicionar-parte-envolvida>

		<modal-confirmacao
			v-if="isModalConfirmacaoVisivel"
			:exibir="isModalConfirmacaoVisivel"
			titulo-modal="Enviar PNCP"
			subtitulo-modal="Deseja realmente enviar?"
			mensagem="Atenção! A unidade compradora será enviada para o PNCP para este órgão. Essa é uma ação permanente!"
			@confirmar="confirmarParteEnvolvida"
			@fechar-modal="fecharModalConfirmacao"
		></modal-confirmacao>
	</az-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import PartesEnvolvidasListagem from '@/views/pages/ata/acessar/gestao-da-ata/partes-envolvidas/listagem/PartesEnvolvidasListagem.vue'
import ModalAdicionarParteEnvolvida from '@/views/pages/ata/acessar/gestao-da-ata/partes-envolvidas/modal-adicionar/ModalAdicionarParteEnvolvida.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'acessar-ata-partes-envolvidas-view',
	components: { ModalConfirmacao, ModalAdicionarParteEnvolvida, PartesEnvolvidasListagem, BotaoPrimario },
	data() {
		return {
			idAta: this.$route.params.id,
			paginacao: paginacaoListagem(['id'], 25),
			isModalAdicionarVisivel: false,
			isModalConfirmacaoVisivel: false,
			parteEnvolvidaAConfirmar: null,
		}
	},
	computed: {
		...mapState({
			listagem: (state) => state.partesEnvolvidas.listagem,
		}),
		isModalAdicionarExibido() {
			return this.isModalAdicionarVisivel && !this.isModalConfirmacaoVisivel
		},
	},
	async mounted() {
		await this.buscarPartesEnvolvidas()
	},
	beforeDestroy() {
		this.limparListagemPartesEnvolvidas()
	},
	methods: {
		...mapActions({
			buscarPartesEnvolvidasPorFiltro: actionTypes.ATA.PARTES_ENVOLVIDAS.BUSCAR_POR_FILTRO,
			criarParteEnvolvidaNaAta: actionTypes.ATA.PARTES_ENVOLVIDAS.CRIAR,
			validarParteEnvolvidaCadastrada: actionTypes.ATA.PARTES_ENVOLVIDAS.VALIDAR,
		}),
		...mapMutations({
			limparListagemPartesEnvolvidas: mutationTypes.ATA.PARTES_ENVOLVIDAS.LIMPAR_LISTAGEM,
		}),
		async buscarPartesEnvolvidas() {
			await this.buscarPartesEnvolvidasPorFiltro({ idAta: this.idAta, paginacao: this.paginacao })
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarPartesEnvolvidas()
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarPartesEnvolvidas()
		},
		abrirModalAdicionar() {
			this.isModalAdicionarVisivel = true
		},
		async fecharModalAdicionar() {
			this.isModalAdicionarVisivel = false
			await this.resetarPaginaListagem()
		},
		async validarParteEnvolvida(parteEnvolvida) {
			await this.validarParteEnvolvidaCadastrada({ idAta: this.idAta, parteEnvolvida })

			this.parteEnvolvidaAConfirmar = parteEnvolvida
			this.isModalConfirmacaoVisivel = true
		},
		fecharModalConfirmacao() {
			this.isModalConfirmacaoVisivel = false
			this.parteEnvolvidaAConfirmar = null
		},
		async confirmarParteEnvolvida() {
			const parteEnvolvida = this.parteEnvolvidaAConfirmar

			this.fecharModalConfirmacao()

			await this.criarParteEnvolvida(parteEnvolvida)
		},
		async criarParteEnvolvida(parteEnvolvida) {
			await this.criarParteEnvolvidaNaAta({ idAta: this.idAta, parteEnvolvida })

			this.$refs.modalAdicionarParteEnvolvida.limparFormulario()
			this.mostrarNotificacaoSucesso('Parte envolvida salva com sucesso!')
		},
	},
}
</script>

<style lang="stylus">
.partes-envolvidas

	.interna
		background-color white !important
		border none !important

	.az-toolbar
		height auto !important

	.az-toolbar .actions
		padding 0 !important
</style>
